// extracted by mini-css-extract-plugin
export default {"addTagForm":"AddTag_addTagForm__dbTF8","submitForm":"AddTag_submitForm__XNykm","add":"AddTag_add__h-Zc9","cancel":"AddTag_cancel__5v8g-"};